import React, { useEffect, useMemo } from 'react';
import { ReactTable } from '@components';
import {
    MRT_ToggleGlobalFilterButton,
    MRT_ToggleDensePaddingButton
} from 'material-react-table';
import {
    Box,
    IconButton,
    Menu,
    MenuItem,
    Modal,
    Tooltip,
    Typography
} from '@mui/material';
import AddEntry from './AddEntry';
import { useDispatch, useSelector } from 'react-redux';
import { apiGetOrder } from '@store';
// import { exportTableToCSV } from '@utils/ordersCsvExport';
import DownloadIcon from '@mui/icons-material/Download'; // Or use a similar icon
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import moment from 'moment/moment';

const OrderLog = ({ openModal, handleCloseModal }) => {
    const dispatch = useDispatch();
    const { order, isGetOrderLoading } = useSelector((state) => state.order);
    const { user } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(apiGetOrder());
    }, [dispatch]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [showOneDayFilteredData, setShowOneDayFilteredData] =
        React.useState(false);
    const [showOneWeekFilteredData, setShowOneWeekFilteredData] =
        React.useState(false);
    const [showOneMonthFilteredData, setShowOneMonthFilteredData] =
        React.useState(false);
    const [showAllData, setShowAllData] = React.useState(false);

    // filter the data based on created_at date
    const todayDate = new Date()
        .toISOString()
        .split('T')[0]
        ?.replace(/-/g, '-');

    // get the date for the last 24 hours
    const lastDayDate = new Date();
    lastDayDate.setDate(lastDayDate.getDate() - 1);
    const lastDayDateString = lastDayDate
        .toISOString()
        .split('T')[0]
        ?.replace(/-/g, '-');
    const filterOneDay = order?.filter((row) => {
        const createdAtDate = row?.created_at
            ?.split('T')[0]
            ?.replace(/-/g, '-');
        return createdAtDate >= lastDayDateString && createdAtDate <= todayDate;
    });

    // get todays date and show the data for the last 7 days
    const lastWeekDate = new Date();
    lastWeekDate.setDate(lastWeekDate.getDate() - 7);
    const lastWeekDateString = lastWeekDate
        .toISOString()
        .split('T')[0]
        ?.replace(/-/g, '-');
    const filterOneWeek = order?.filter((row) => {
        const createdAtDate = row?.created_at
            ?.split('T')[0]
            ?.replace(/-/g, '-');
        return (
            createdAtDate >= lastWeekDateString && createdAtDate <= todayDate
        );
    });

    // get the date for the last 30 days
    const lastMonthDate = new Date();
    lastMonthDate.setDate(lastMonthDate.getDate() - 30);
    const lastMonthDateString = lastMonthDate
        .toISOString()
        .split('T')[0]
        ?.replace(/-/g, '-');
    const filterOneMonth = order?.filter((row) => {
        const createdAtDate = row?.created_at
            ?.split('T')[0]
            ?.replace(/-/g, '-');
        return (
            createdAtDate >= lastMonthDateString && createdAtDate <= todayDate
        );
    });

    const handleShowOneDayFilteredData = () => {
        setShowOneDayFilteredData(true);
        setShowOneWeekFilteredData(false);
        setShowOneMonthFilteredData(false);
        setShowAllData(false);
        handleClose();
    };

    const handleShowOneWeekFilteredData = () => {
        setShowOneDayFilteredData(false);
        setShowOneWeekFilteredData(true);
        setShowOneMonthFilteredData(false);
        setShowAllData(false);
        handleClose();
    };

    const handleShowOneMonthFilteredData = () => {
        setShowOneDayFilteredData(false);
        setShowOneWeekFilteredData(false);
        setShowOneMonthFilteredData(true);
        setShowAllData(false);
        handleClose();
    };

    const handleShowAllData = () => {
        setShowOneDayFilteredData(false);
        setShowOneWeekFilteredData(false);
        setShowOneMonthFilteredData(false);
        setShowAllData(true);
        handleClose();
    };

    const GVMCompanyDownloadFormat = [
        'Seller',
        'Buyer',
        'TransactionDate',
        'DealID',
        'UTI',
        'DeliveryPoint',
        'ContractQuantity',
        'StartDeliveryDate',
        'EndDeliveryDate',
        'ContractPrice',
        'Currency',
        'Trader',
        'ContractType',
        'ShareholderProduct',
        'ClientProduct'
    ];

    // download the data according to filter
    const GVMCompanyDownloadData = showAllData
        ? order?.map((row) => {
            return `${row?.data?.seller || 'NA'};${row?.data?.buyer || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD') + '-' + row?.uuid?.split('-')[4] || 'NA'};${row?.uuid || 'NA'};${row?.data?.deliverypoint || 'NA'};${row?.data?.volume || 'NA'};${moment(row?.contract_date_from_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.contract_date_to_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${row?.order_price_str || 'NA'};${row?.data?.currency || 'NA'};${row?.username || 'NA'};${row?.data?.exitpoint?.name?.split('-')[1] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[0] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[1]?.split('-')[0] || 'NA'}`;
        })
        : showOneDayFilteredData
            ? filterOneDay?.map((row) => {
                return `${row?.data?.seller || 'NA'};${row?.data?.buyer || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD') + '-' + row?.uuid?.split('-')[4] || 'NA'};${row?.uuid || 'NA'};${row?.data?.deliverypoint || 'NA'};${row?.data?.volume || 'NA'};${moment(row?.contract_date_from_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.contract_date_to_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${row?.order_price_str || 'NA'};${row?.data?.currency || 'NA'};${row?.username || 'NA'};${row?.data?.exitpoint?.name?.split('-')[1] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[0] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[1]?.split('-')[0] || 'NA'}`;
            })
            : showOneWeekFilteredData
                ? filterOneWeek?.map((row) => {
                    return `${row?.data?.seller || 'NA'};${row?.data?.buyer || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD') + '-' + row?.uuid?.split('-')[4] || 'NA'};${row?.uuid || 'NA'};${row?.data?.deliverypoint || 'NA'};${row?.data?.volume || 'NA'};${moment(row?.contract_date_from_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.contract_date_to_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${row?.order_price_str || 'NA'};${row?.data?.currency || 'NA'};${row?.username || 'NA'};${row?.data?.exitpoint?.name?.split('-')[1] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[0] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[1]?.split('-')[0] || 'NA'}`;
                })
                : showOneMonthFilteredData
                    ? filterOneMonth?.map((row) => {
                        return `${row?.data?.seller || 'NA'};${row?.data?.buyer || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD') + '-' + row?.uuid?.split('-')[4] || 'NA'};${row?.uuid || 'NA'};${row?.data?.deliverypoint || 'NA'};${row?.data?.volume || 'NA'};${moment(row?.contract_date_from_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.contract_date_to_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${row?.order_price_str || 'NA'};${row?.data?.currency || 'NA'};${row?.username || 'NA'};${row?.data?.exitpoint?.name?.split('-')[1] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[0] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[1]?.split('-')[0] || 'NA'}`;
                    })
                    : order?.map((row) => {
                        return `${row?.data?.seller || 'NA'};${row?.data?.buyer || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.created_at).format('YYYY-MM-DD') + '-' + row?.uuid?.split('-')[4] || 'NA'};${row?.uuid || 'NA'};${row?.data?.deliverypoint || 'NA'};${row?.data?.volume || 'NA'};${moment(row?.contract_date_from_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${moment(row?.contract_date_to_cet_iso)?.format('YYYY-MM-DD HH:mm:ss') || 'NA'};${row?.order_price_str || 'NA'};${row?.data?.currency || 'NA'};${row?.username || 'NA'};${row?.data?.exitpoint?.name?.split('-')[1] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[0] || 'NA'};${row?.data?.exitpoint?.name?.split('|')[1]?.split('-')[0] || 'NA'}`;
                    });

    const handleGVMCompanyFormatDownload = () => {
        const header = GVMCompanyDownloadFormat.join(';');
        const data = GVMCompanyDownloadData?.map((row) => {
            return `${row}`;
        });
        const csv = `${header}\n${data?.join('\n')}`;
        const blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'order_log.csv';
        a.click();
    };

    const DefaultDownloadFormat = [
        'Contract',
        'Buyer',
        'Seller',
        'DeliveryPoint',
        'Volume',
        'Units',
        'Price',
        'Currency',
        'Type',
        'Status',
        'Account',
        'CreatedAt',
        'DeliveryStart',
        'DeliveryEnd'
    ];

    // download the data according to filter
    const DefaultDownloadData = showAllData
        ? order?.map((row) => {
            return `${row?.data?.sym || 'NA'},${row?.data?.buyer || 'NA'},${row?.data?.seller || 'NA'},${row?.data?.deliverypoint || 'NA'},${row?.data?.volume || 'NA'},${row?.data?.units || 'NA'},${row?.order_price_str || 'NA'},${row?.data?.currency || 'NA'},${row?.data?.type || 'NA'},${row?.order_status || 'Completed'},${row?.username || 'NA'},${row?.created_at || 'NA'},${row?.contract_date_from_cet_iso || 'NA'},${row?.contract_date_to_cet_iso || 'NA'}`;
        })
        : showOneDayFilteredData
            ? filterOneDay?.map((row) => {
                return `${row?.data?.sym || 'NA'},${row?.data?.buyer || 'NA'},${row?.data?.seller || 'NA'},${row?.data?.deliverypoint || 'NA'},${row?.data?.volume || 'NA'},${row?.data?.units || 'NA'},${row?.order_price_str || 'NA'},${row?.data?.currency || 'NA'},${row?.data?.type || 'NA'},${row?.order_status || 'Completed'},${row?.username || 'NA'},${row?.created_at || 'NA'},${row?.contract_date_from_cet_iso || 'NA'},${row?.contract_date_to_cet_iso || 'NA'}`;
            })
            : showOneWeekFilteredData
                ? filterOneWeek?.map((row) => {
                    return `${row?.data?.sym || 'NA'},${row?.data?.buyer || 'NA'},${row?.data?.seller || 'NA'},${row?.data?.deliverypoint || 'NA'},${row?.data?.volume || 'NA'},${row?.data?.units || 'NA'},${row?.order_price_str || 'NA'},${row?.data?.currency || 'NA'},${row?.data?.type || 'NA'},${row?.order_status || 'Completed'},${row?.username || 'NA'},${row?.created_at || 'NA'},${row?.contract_date_from_cet_iso || 'NA'},${row?.contract_date_to_cet_iso || 'NA'}`;
                })
                : showOneMonthFilteredData
                    ? filterOneMonth?.map((row) => {
                        return `${row?.data?.sym || 'NA'},${row?.data?.buyer || 'NA'},${row?.data?.seller || 'NA'},${row?.data?.deliverypoint || 'NA'},${row?.data?.volume || 'NA'},${row?.data?.units || 'NA'},${row?.order_price_str || 'NA'},${row?.data?.currency || 'NA'},${row?.data?.type || 'NA'},${row?.order_status || 'Completed'},${row?.username || 'NA'},${row?.created_at || 'NA'},${row?.contract_date_from_cet_iso || 'NA'},${row?.contract_date_to_cet_iso || 'NA'}`;
                    })
                    : order?.map((row) => {
                        return `${row?.data?.sym || 'NA'},${row?.data?.buyer || 'NA'},${row?.data?.seller || 'NA'},${row?.data?.deliverypoint || 'NA'},${row?.data?.volume || 'NA'},${row?.data?.units || 'NA'},${row?.order_price_str || 'NA'},${row?.data?.currency || 'NA'},${row?.data?.type || 'NA'},${row?.order_status || 'Completed'},${row?.username || 'NA'},${row?.created_at || 'NA'},${row?.contract_date_from_cet_iso || 'NA'},${row?.contract_date_to_cet_iso || 'NA'}`;
                    });

    const handleDefaultFormatDownload = () => {
        const header = DefaultDownloadFormat?.join(';');
        const data = DefaultDownloadData?.map((row) => {
            return `${row}`;
        });
        const csv = `${header}\n${data?.join('\n')}`;
        const blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'order_log.csv';
        a.click();
    };

    const columns = useMemo(
        () => [
            {
                header: 'Contract',
                id: 'contract',
                accessorFn: ({ contract }) => contract || '',
                Cell: ({ row }) => (
                    <Typography
                        sx={{
                            color: '#3B9D9D',
                            fontSize: 'inherit',
                            fontWeight: 'bold',
                            pl: '8px'
                        }}
                    >
                        {row?.original?.data?.sym}
                    </Typography>
                ),
                size: 50
            },
            {
                header: 'Buyer',
                id: 'buyer',
                accessorFn: ({ buyer }) => buyer || '',
                Cell: ({ row }) => (
                    <Typography
                        sx={{
                            fontSize: 'inherit',
                            color: 'black'
                        }}
                    >
                        {row?.original?.data?.buyer}
                    </Typography>
                ),
                size: 30
            },
            {
                header: 'Seller',
                id: 'seller',
                accessorFn: ({ seller }) => seller || '',
                Cell: ({ row }) => (
                    <Typography
                        sx={{
                            fontSize: 'inherit',
                            color: 'black'
                        }}
                    >
                        {row?.original?.data?.seller}
                    </Typography>
                ),
                size: 30
            },
            {
                header: 'Delivery-Point',
                id: 'deliverypoint',
                accessorFn: ({ deliverypoint }) => deliverypoint || '',
                Cell: ({ row }) => (
                    <Typography
                        sx={{
                            fontSize: 'inherit',
                            color: 'black'
                        }}
                    >
                        {row?.original?.data?.deliverypoint}
                    </Typography>
                ),
                size: 30
            },
            {
                header: 'Volume',
                id: 'volume_str',
                accessorFn: ({ volume_str }) =>
                    volume_str?.replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },

            {
                header: 'Units',
                id: 'units',
                accessorFn: ({ units }) => units || 'MWh/h',
                Cell: ({ row }) => (
                    <Typography
                        sx={{
                            fontSize: 'default',
                            color: '#27A9FF'
                        }}
                    >
                        MWh/h
                    </Typography>
                ),
                size: 30
            },
            {
                header: 'Price',
                id: 'order_price_str',
                accessorFn: ({ order_price_str }) =>
                    order_price_str?.replace(/\B(?=(\d{3})+(?!\d))/g, ',') ||
                    '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: 'Currency',
                id: 'currency',
                accessorFn: ({ currency }) => currency || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: 'Type',
                id: 'type',
                Cell: ({ row }) => (
                    <>
                        {row?.original?.data?.type === 'sell' ? (
                            <Typography
                                sx={{
                                    fontSize: 'inherit',
                                    color: 'rgba(235, 105, 105, 1)'
                                }}
                            >
                                Sell
                            </Typography>
                        ) : (
                            <Typography
                                sx={{
                                    fontSize: 'inherit',
                                    color: 'rgba(39, 169, 255, 1)'
                                }}
                            >
                                Buy
                            </Typography>
                        )}
                    </>
                ),
                size: 50
            },
            {
                header: 'Status',
                id: 'order_status',
                accessorFn: ({ order_status }) => order_status || 'Completed',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },

            {
                header: 'Account',
                id: 'username',
                accessorFn: ({ username }) => username || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: 'Created-At',
                id: 'created_at',
                accessorFn: ({ created_at }) => created_at || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: 'Delivery Start',
                id: 'contract_date_from_cet_iso',
                accessorFn: ({ contract_date_from_cet_iso }) =>
                    contract_date_from_cet_iso || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            },
            {
                header: 'Delivery End',
                id: 'contract_date_to_cet_iso',
                accessorFn: ({ contract_date_to_cet_iso }) =>
                    contract_date_to_cet_iso || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
                size: 50
            }
        ],
        []
    );

    return (
        <>
            <Modal open={openModal} onClose={handleCloseModal}>
                <AddEntry handleClose={handleCloseModal} open={openModal} />
            </Modal>
            <ReactTable
                renderToolbarInternalActions={({ table }) => (
                    <Box sx={{ display: 'flex' }}>
                        <>
                            <Tooltip title="Filter">
                                <IconButton
                                    aria-controls={
                                        open ? 'basic-menu' : undefined
                                    }
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                    sx={{
                                        background: 'none',
                                        border: 'none',
                                        display: 'flex',
                                        alignItems: 'center',
                                        p: '0.5rem',
                                        '&:hover': {
                                            backgroundColor: '#f5f5f5'
                                        }
                                    }}
                                >
                                    <FilterAltIcon sx={{ color: 'gray' }} />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button'
                                }}
                            >
                                <MenuItem
                                    onClick={handleShowOneDayFilteredData}
                                >
                                    One day
                                </MenuItem>
                                <MenuItem
                                    onClick={handleShowOneWeekFilteredData}
                                >
                                    One week
                                </MenuItem>
                                <MenuItem
                                    onClick={handleShowOneMonthFilteredData}
                                >
                                    One month
                                </MenuItem>
                                <MenuItem onClick={handleShowAllData}>
                                    All
                                </MenuItem>
                            </Menu>
                        </>
                        <Tooltip
                            title={
                                user?.Company === 'GVM'
                                    ? 'Download GVM CSV'
                                    : 'Download CSV'
                            }
                        >
                            <IconButton
                                onClick={
                                    user?.Company === 'GVM'
                                        ? handleGVMCompanyFormatDownload
                                        : handleDefaultFormatDownload
                                }
                                // onClick={() => {
                                //     const header =
                                //         'Seller,Buyer,Transaction Date,Deal ID,UTI,Delivery Point,Contract Quantity,Start Delivery Date,End Delivery Date,Contract Price,Currency,Trader,Contract Type,Shareholder Product,Client Product';
                                //     const data = order.map((row) => {
                                //         return `${row?.data?.seller || 'NA'},${row?.data?.buyer || 'NA'},${row?.created_at || 'NA'},${row?.deal_id || 'NA'},${row?.uuid || 'NA'},${row?.data?.deliverypoint || 'NA'},${row?.data?.volume || 'NA'},${row?.contract_date_from_cet || 'NA'},${row?.contract_date_to_cet || 'NA'},${row?.order_price_str || 'NA'},${row?.data?.currency || 'NA'},${row?.username || 'NA'},${row?.data?.exitpoint?.company || 'NA'},${row?.data?.exitpoint?.location?.split('|')[0] || 'NA'},${row?.data?.exitpoint?.location?.split('|')[1] || 'NA'}`;
                                //     });
                                //     const csv = `${header}\n${data?.join('\n')}`;
                                //     const blob = new Blob([csv], {
                                //         type: 'text/csv;charset=utf-8;'
                                //     });
                                //     const url = URL.createObjectURL(blob);
                                //     const a = document.createElement('a');
                                //     a.href = url;
                                //     a.download = 'order_log.csv';
                                //     a.click();
                                // }}
                                // sx={{
                                //     cursor: 'pointer',
                                //     background: 'none',
                                //     border: 'none',
                                //     display: 'flex',
                                //     alignItems: 'center',
                                //     p: '0.5rem',
                                //     '&:hover': { backgroundColor: '#f5f5f5' }
                                // }}
                                // aria-label="Download CSV"
                            >
                                <DownloadIcon sx={{ color: 'gray' }} />
                            </IconButton>
                        </Tooltip>
                        <MRT_ToggleGlobalFilterButton table={table} />
                        <MRT_ToggleDensePaddingButton table={table} />
                    </Box>
                )}
                headerText={'Order Logs'}
                columns={columns}
                data={
                    showAllData
                        ? order
                        : showOneDayFilteredData
                        ? filterOneDay
                        : showOneWeekFilteredData
                        ? filterOneWeek
                        : showOneMonthFilteredData
                        ? filterOneMonth
                        : order
                }
                isLoading={isGetOrderLoading}
                showCellBorders={true}
            />
        </>
    );
};

export default OrderLog;
